export default "__VITE_ASSET__C2B7htjN__"